// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  GenericActionResult,
  GenericActionResultFromJSON,
  GenericActionResultToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
  Tag,
  TagFromJSON,
  TagToJSON,
  TagPayload,
  TagPayloadFromJSON,
  TagPayloadToJSON,
} from "../models";

export interface DeleteTagRequest {
  id: number;
}

export interface GetTagRequest {
  id: number;
}

export interface GetTagCountRequest {
  project: number;
  filter?: string;
}

export interface UpdateTagRequest {
  id: number;
  tagPayload?: TagPayload;
}

/**
 * no description
 */
export class TagsApi extends runtime.BaseAPI {
  /**
   * Deletes a tag
   * Deletes given tag
   */
  async deleteTagRaw(
    requestParameters: DeleteTagRequest
  ): Promise<runtime.ApiResponse<GenericActionResult>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteTag."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/tags/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GenericActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Deletes a tag
   * Deletes given tag
   */
  async deleteTag(
    requestParameters: DeleteTagRequest
  ): Promise<GenericActionResult> {
    const response = await this.deleteTagRaw(requestParameters);
    return await response.value();
  }

  /**
   * Fetches the details of a tag
   * Get tag
   */
  async getTagRaw(
    requestParameters: GetTagRequest
  ): Promise<runtime.ApiResponse<Tag>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getTag."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/tags/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TagFromJSON(jsonValue)
    );
  }

  /**
   * Fetches the details of a tag
   * Get tag
   */
  async getTag(requestParameters: GetTagRequest): Promise<Tag> {
    const response = await this.getTagRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get tags' count for a project
   * Get tags' count
   */
  async getTagCountRaw(
    requestParameters: GetTagCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getTagCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/tags/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get tags' count for a project
   * Get tags' count
   */
  async getTagCount(requestParameters: GetTagCountRequest): Promise<Count> {
    const response = await this.getTagCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Updates a tag
   * Updates a tag
   */
  async updateTagRaw(
    requestParameters: UpdateTagRequest
  ): Promise<runtime.ApiResponse<Tag>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateTag."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/tags/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TagPayloadToJSON(requestParameters.tagPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TagFromJSON(jsonValue)
    );
  }

  /**
   * Updates a tag
   * Updates a tag
   */
  async updateTag(requestParameters: UpdateTagRequest): Promise<Tag> {
    const response = await this.updateTagRaw(requestParameters);
    return await response.value();
  }
}
